// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

export const userStates = {
  LOGGED_IN: "logged-in",
  LOGGED_OUT: "logged-out",
  UNKNOWN: "unknown",
};
